// extracted by mini-css-extract-plugin
module.exports = {"root":"CardInset_root__2O_Dq","top":"CardInset_top__An3F-","bottom":"CardInset_bottom__2nFbi","left":"CardInset_left__1fJYN","right":"CardInset_right__wGf3O"};